// removed by extract-text-webpack-plugin
module.exports = {"newDocument":"CurrYLorenG_j-j8Jdz-j","box":"_27REYGW_3rfXKWvbhz98We","boxTitle":"_2N9TrBeicBLHinHBQ02izG","boxSubtitle":"gp1xPIer-uI8vEjJUkzfW","boxBar":"_1V63yxX7MJLSZOyFBuojjj","content":"_2gpPK42a907IHYVFrQvz_l","listing":"_2PNwdKBNdCHWhBTQidGRHY","listingHeader":"emnm7YXASfwREBXf0vFID","listingContent":"GrM2skhbKhMlrPjg7nUfu","newDocumentToolbar":"_3y-Jwc0ekHhFbVgh2Se1_R","exercisesList":"_3dUUHR8Ew4zYpRoLckJCSH","exercicesListItem":"lWhiCTJRSNtHt-yBCGZVN","boxInfo":"_2btq0vZBsMLDd66US7jNt0"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Dashboard/Dashboard.scss
// module id = 963
// module chunks = 0